import { styled } from '@mui/material/styles';

const StyledSpeakerOption = styled('div')`
  display: flex;
  align-items: center;
`;

export { StyledSpeakerOption };
